"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants");

var isCharity = function isCharity(challenge) {
  return !!(challenge && challenge.challengeType === _constants.CHARITY);
};

var _default = isCharity;
exports["default"] = _default;
//# sourceMappingURL=isCharity.js.map